import { Typography } from "@mui/material";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { useSearchParams } from "react-router-dom";

import { useTeachingPreview } from "../hooks/useTeachingPreview";

export function LessonNavigation() {
	const { lessons, currentLesson } = useTeachingPreview();
	const [, setSearchParams] = useSearchParams();

	if (!currentLesson) {
		return null;
	}

	const index = lessons.findIndex((lesson) => lesson.id === currentLesson.id);

	if (index === -1) {
		return null;
	}

	return (
		<div className="lesson-navigation-container item-separator-big">
			{index > 0 && (
				<div
					className="lesson-navigation-button"
					onClick={() => {
						setSearchParams((prev) => {
							prev.set("class", lessons[index - 1].id.toString());
							return prev;
						});
					}}>
					<FaChevronLeft className="normal-icon" />
					<Typography className="normal-text">Previous Class</Typography>
				</div>
			)}
			<div style={{ flex: 1 }} />
			{index < lessons.length - 1 && (
				<div
					className="lesson-navigation-button"
					onClick={() => {
						setSearchParams((prev) => {
							prev.set("class", lessons[index + 1].id.toString());
							return prev;
						});
					}}>
					<Typography className="normal-text">Next Class</Typography>
					<FaChevronRight className="normal-icon" />
				</div>
			)}
		</div>
	);
}
